'use client'

import { FC } from 'react'
import { usePod4Prices, usePod4UltraPrices, usePodPrices, useSleepEssentialsBundlePrices } from 'stores/prices'
import { useRegionSellsBundle } from 'stores/product'
import { useStore } from 'stores/StoreProvider'

export const TermsAndConditionsContent: FC = () => {
	const settings = useStore((state) => state.settings.settings)
	const regionSellsBundle = useRegionSellsBundle()

	const pod4UltraPrices = usePod4UltraPrices()
	const pod4Prices = usePod4Prices()
	const podPrices = usePodPrices()
	const sleepEssentialsPrices = useSleepEssentialsBundlePrices()

	return (
		<>
			<h2>{settings.saleName} Terms and Conditions:</h2>
			<p>
				{pod4UltraPrices.discountFormatted} off the full price Pod 4 Ultra, {pod4Prices.discountFormatted} off full price Pod 4
				{regionSellsBundle
					? `, and an additional ${podPrices.discountFormatted} off the 5-layer mattress (US only) and ${sleepEssentialsPrices.discountFormatted} sleep essentials bundle (US only). Discounts are automatically applied at checkout when eligible products are added to the cart during the sale period.
`
					: '.'}
			</p>

			<p>{regionSellsBundle ? settings.checkoutLegalese : settings.checkoutLegalese.split('.')[0]}</p>

			<p>Offer open to individuals who reside in eligible locations as defined in Eight Sleep's shipping policies. Cannot be combined with any other promo code or offer. Valid while supplies last.</p>

			<p>Eight Sleep reserves the right to cancel, modify, or suspend the offer at any time without notice, even after the sale has started, at its sole discretion.</p>

			<p>All purchases made during the sale period are subject to Eight Sleep's standard return and refund policy, unless otherwise specified in these terms. Additional restrictions may apply.</p>

			<p>
				Offer cannot be applied to previous purchases or pending orders, except for products within their 30-day trial period. For these eligible products, Eight Sleep will honor a price adjustment if
				customers contact Customer Service. No price adjustments or further modifications will be made beyond this exception.
			</p>
		</>
	)
}
